<template>
  <Card :title="$t('global.webmail')">
    <LoadingState v-if="isOpening || loading" />
    <CardActionContent v-else :description="webmailDescription" :buttons="webmailActions" />
  </Card>
</template>

<script>
import Card from "@/components/display/Card";
import CardActionContent from "@/components/display/card-sub-components/CardActionContent";
import LoadingState from "@/components/display/LoadingState";
import NavLink from "@/classes/NavLink";
import { ref } from "@vue/composition-api";
import store from "@/store";

export default {
  name: "WebMail",
  components: { Card, CardActionContent, LoadingState },
  props: {
    site: {
      type: Object,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { root }) {
    const isOpening = ref(false);

    // retrieves the webmail url from the api, then attempts to open it in a new tab
    const launchWebmail = () => {
      isOpening.value = true;
      store
        .dispatch("emailBoxes/getWebmailUrl", props.site.id)
        .then((url) => {
          window.open(url, "_blank");
        })
        .finally(() => {
          isOpening.value = false;
        });
    };

    const webmailDescription = root.$t("global.webmail-description");
    const webmailActions = [
      new NavLink(root.$t("global.launch-webmail"), null, launchWebmail, false, "primary"),
    ];

    return {
      webmailDescription,
      webmailActions,
      isOpening,
    };
  },
};
</script>
